module.exports = __webpack_public_path__ + "profile-bg-dark.78c6c8de9a377d2b81ab.png";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/images/profile-bg-dark.png
// module id = ../../../../../src/assets/layout/images/profile-bg-dark.png
// module chunks = 2